import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Grid2, Stack } from "@mui/material";
import teamDefault from "./../assets/images/teamDefault.png";
import { useNavigate } from "react-router-dom";
import { dateAndTime } from "../values/dateFormatter";

const MatchDetailsCard = (props) => {
  const navigate = useNavigate();
  const { enableShadow, customStyles, item, enableOnClick } = props;

  const _navigateToMatchDetails = (item) => {
    if (enableOnClick) {
      navigate("/matchDetails", {
        matchDetails: item,
        backSource: true,
      });
    }
  };

  return (
    <Card
      variant="outlined"
      sx={{
        m: 2,
        borderRadius: "17px",
      }}
      onClick={_navigateToMatchDetails}
    >
      <CardContent sx={{ padding: "0px" }}>
        <Stack
          direction={"row"}
          sx={{ borderBottom: 1, borderColor: "rgba(0, 0, 0, 0.19)" }}
        >
          <Stack sx={{ flex: 1, padding: "16px" }}>
            <Typography variant="h6" paddingLeft={"4px"} paddingTop={"10px"}>
              Match Details
            </Typography>
          </Stack>
        </Stack>
        <Stack sx={{ padding: "16px" }}>
          {/* <Stack mb={1.5}>
            <Typography
              variant="h6"
              sx={{ fontSize: "20px", fontWeight: 400 }}
              mb={0.6}
            >
              Series Name
            </Typography>
            <Typography gutterBottom variant="subtitle1">
              Syed Mushtaq Ali Trophy
            </Typography>
          </Stack> */}

          {/* Match Date */}
          <Stack mb={1.5}>
            <Typography
              variant="h6"
              sx={{ fontSize: "20px", fontWeight: 400 }}
              mb={0.6}
            >
              Match Date
            </Typography>
            <Typography variant="subtitle1">
              {dateAndTime(item?.matchTime) ?? "Loading"}
            </Typography>
          </Stack>

          {/* Umpires and scorers */}
          {/* <Stack direction={"row"} spacing={6} mb={1.5}> */}
          {/* <Stack>
              <Typography
                mb={0.6}
                variant="h6"
                sx={{ fontSize: "20px", fontWeight: 400 }}
              >
                Umpires
              </Typography>
              <Typography variant="subtitle1">23/11/2023</Typography>
            </Stack> */}

          <Grid2 container size={{ xs: 12, sm: 12, md: 6 }} sx={{ mb: 2 }}>
            {item?.scorers?.map((ele, index) => (
              <Grid2>
                <Typography
                  mb={0.6}
                  variant="h6"
                  sx={{ fontSize: "20px", fontWeight: 400 }}
                >
                  Scorer {index + 1}
                </Typography>
                <Typography variant="subtitle1">{ele?.name}</Typography>
              </Grid2>
            ))}
          </Grid2>

          <Grid2 container size={{ xs: 12, sm: 12, md: 6 }} sx={{ mb: 2 }}>
            {item?.umpires?.map((ele, index) => (
              <Grid2>
                <Typography
                  mb={0.6}
                  variant="h6"
                  sx={{ fontSize: "20px", fontWeight: 400 }}
                >
                  Umpire {index + 1}
                </Typography>
                <Typography variant="subtitle1">{ele?.name}</Typography>
              </Grid2>
            ))}
          </Grid2>

          {/* </Stack> */}

          <Stack>
            <Typography
              mb={0.6}
              variant="h6"
              sx={{ fontSize: "20px", fontWeight: 400 }}
            >
              Location
            </Typography>
            <Typography variant="subtitle1">Turf,Mumbai</Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default MatchDetailsCard;
